import { render } from "./AdminDesktopNav.vue?vue&type=template&id=ccd650da"
import script from "./AdminDesktopNav.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdminDesktopNav.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script